import PropTypes from 'prop-types';
import React from 'react';

export default function Duration(_ref) {
  var className = _ref.className,
      seconds = _ref.seconds;

  var time = '--:--';
  if (seconds !== Infinity) {
    if (seconds >= 0) {
      time = format(seconds);
    } else {
      time = '0:00';
    }
  }
  return React.createElement(
    'time',
    { dateTime: 'P' + Math.round(seconds) + 'S', className: className },
    time
  );
}

function format(seconds) {
  var date = new Date(seconds * 1000);
  var hh = date.getUTCHours();
  var mm = date.getUTCMinutes();
  var ss = pad(date.getUTCSeconds());
  if (hh) {
    return hh + ':' + pad(mm) + ':' + ss;
  }
  return mm + ':' + ss;
}

function pad(string) {
  return ('0' + string).slice(-2);
}

Duration.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  seconds: PropTypes.number
} : {};

Duration.defaultProps = {
  className: '',
  seconds: 0
};